import { Field, Layout } from "@introist/react-foundation/v2";
import { TextInput } from "../../../components/atoms";
import { ConnectFormProps } from "../views/DataSourceConnectionSetupView/steps/DataSourceConnectionForm";

type SympaConfig = {
  apiKey: string;
  employeeApiPath: string;
};
export const SympaConnectForm = ({ values, onChange }: ConnectFormProps) => {
  const credentials = (values?.credentials as SympaConfig) ?? {
    apiKey: "",
    employeeApiPath: ""
  };

  return (
    <Layout.Group vertical gap="xLarge">
      <TextInput label="Name" value={values?.name} onChange={name => onChange({ name })} />
      <Field title="Api key">
        <TextInput
          placeholder="Api key"
          value={credentials.apiKey}
          type="password"
          onChange={apiKey =>
            onChange({
              credentials: { ...credentials, apiKey }
            })
          }
        />
      </Field>
      <Field title="Api path">
        <TextInput
          placeholder="Api path (without leading /)"
          value={credentials.employeeApiPath}
          onChange={employeeApiPath =>
            onChange({
              credentials: { ...credentials, employeeApiPath }
            })
          }
        />
      </Field>
    </Layout.Group>
  );
};
